import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiPhotoLogCreateRequestParams,
	IApiPhotoLogCreateRequestBody,
	IApiPhotoLogCreateResponseData,

	IApiPhotoLogUpdateRequestParams,
	IApiPhotoLogUpdateRequestBody,
	IApiPhotoLogUpdateResponseData,
} from './types';

export class PhotoLogApi extends BaseApi {

	async create(options: IRequestOptions<IApiPhotoLogCreateRequestParams, IApiPhotoLogCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiPhotoLogCreateRequestBody, IApiPhotoLogCreateResponseData>({
			url: getParametrizedUrl(URLS_API.PHOTO_LOG),
			data: body,
			isNoProcessData: true,
		});
	}

	async update(options: IRequestOptions<IApiPhotoLogUpdateRequestParams, IApiPhotoLogUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiPhotoLogUpdateRequestBody, IApiPhotoLogUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.PHOTO_LOG_ITEM, params as unknown as Record<string, string>),
			data: body,
			isNoProcessData: true,
		});
	}

}
